/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_FaqInputs */

const en_learn_faq = /** @type {(inputs: Learn_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[FAQ](/faq). Commonly asked questions about AI safety and PauseAI.`)
};

/**
* | output |
* | --- |
* | "[FAQ](/faq). Commonly asked questions about AI safety and PauseAI." |
*
* @param {Learn_FaqInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const learn_faq = /** @type {((inputs?: Learn_FaqInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_FaqInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_learn_faq(inputs)
});